module.exports = __webpack_public_path__ + "static/media/Group 1329.b7dd8bbe.png";